import TabPanel from "../../TabPanel";

import { useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";

import { Box, Typography, Divider, Button } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import FaceIcon from "@mui/icons-material/Face";
import Chip from "@mui/material/Chip";
// import LoginInfoBox from "./Boxs/LoginInfoBox"
// import UserInfoBox from "./Boxs/UserInfoBox"
// import ChangePhoneNumber from "./Boxs/ChangePhoneNumber"
// import EditUserName from "./Boxs/EditUserName"
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import AppSettingsAltIcon from "@mui/icons-material/AppSettingsAlt";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Tooltip from "@mui/material/Tooltip";
import RegisterInfluencer from "./Boxs/RegisterInfluencer/RegisterInfluencer";
import RequestCode from "./Boxs/RequestCode/RequsetCode";
// import SearchSubtitles from "./Boxs/SearchSubtitles/SearchSubtitles";

function InfluencerTabs(props) {
  const { influencerTabsValue, handlesetInfluencerTabsValue } = props;

  return (
    <Box component="main">
      <TabPanel value={influencerTabsValue} index={0}>
        <Typography>
        </Typography>
        <RegisterInfluencer handlesetInfluencerTabsValue={handlesetInfluencerTabsValue} />
      </TabPanel>
      <TabPanel value={influencerTabsValue} index={1}>
        <RequestCode />
      </TabPanel>
    </Box>
  );
}

export default InfluencerTabs;
